import { useEffect } from 'react';
import Logo from '../assets/logo.png';
import { tg } from '../hooks/useTelegram';

/**
 * Hard stop screen shown instead of the whole app when the service is
 * suspended (see `isSuspended` in tools/parameters.js). Rendered above
 * Layout, so no route mounts and no API request is ever fired — closing
 * the service means closing it for real, not just hiding the menu.
 */
const SuspendedPage = () => {
    // Any Telegram button left over from a previous session would lead
    // nowhere on this screen, so make sure both are down before we paint.
    useEffect(() => {
        const wa = tg.webApp;
        if (!wa) return;
        try { wa.MainButton?.hide(); } catch (e) {}
        try { wa.BackButton?.hide(); } catch (e) {}
    }, []);

    const close = () => {
        try { tg.haptic('light'); } catch (e) {}
        try { tg.webApp?.close(); } catch (e) {}
    };

    return <div className="errorContainer suspendedContainer">
        <img src={Logo} alt="Logo" className="logo" />
        <h3 className="suspended-title">Сервис временно приостановлен</h3>
        <p className="suspended-text">
            По решению компании сервис личных нужд временно приостановил свою работу.
        </p>
        <p className="suspended-text suspended-text-hint">
            О возобновлении мы сообщим дополнительно.
        </p>
        {tg.webApp ? <div className="button primary" onClick={close}>
            <span>Закрыть</span>
        </div> : null}
    </div>
}

export default SuspendedPage;
